// for common data
export const GET_PREVIOUS_DATA = 'GET_PREVIOUS_DATA'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
